/* global axios */
import ApiClient from '../ApiClient';

class KanbanColumnsAPI extends ApiClient {
  constructor() {
    super('kanban/boards', { accountScoped: true });
  }

  index(boardId) {
    return axios.get(`${this.url}/${boardId}/columns`);
  }

  create(boardId, data) {
    return axios.post(`${this.url}/${boardId}/columns`, {
      kanban_column: data,
    });
  }

  update(boardId, columnId, data) {
    return axios.patch(`${this.url}/${boardId}/columns/${columnId}`, {
      kanban_column: data,
    });
  }

  delete(boardId, columnId) {
    return axios.delete(`${this.url}/${boardId}/columns/${columnId}`);
  }

  reorder(boardId, orderedIds) {
    return axios.post(`${this.url}/${boardId}/columns/reorder`, {
      ordered_ids: orderedIds,
    });
  }
}

export default new KanbanColumnsAPI();
